import { requestJSON } from './request'

// result returned by ElasticSearch engine

export enum SearchResultStatus {
  draft = '1',
  published = '2'
}

export interface SearchResult {
  id: string
  status: SearchResultStatus
  title?: string
  category?: string
  is_featured?: boolean
  topics?: string
  username?: string
}

export enum SearchResultType {
  article = 'ircamforum.forumarticle',
  guestarticle = 'ircamforum.guestarticle',
  event = 'mezzanine_agenda.event',
  guestevent = 'ircamforum.guestevent',
  project = 'organization_projects.project',
  collection = 'ircamforum.collection',
  forumuser = 'ircamforum.forumuser'
}
export function getApiUrl (): string {
  return window.location.origin + '/api/search/'
}

export function getIdNumber (idStr: string): number {
  const arr = String(idStr).split('.')
  return parseInt(arr[arr.length - 1])
}

export async function getSearchResults (url: string, controller?: AbortController): Promise<SearchResult[]> {
  if (controller !== null) {
    return await requestJSON(url, { signal: controller?.signal })
  } else {
    return await requestJSON(url)
  }
}

export async function getSearchInputResults (query: string, controller?: AbortController): Promise<SearchResult[]> {
  if (controller !== null) {
    return await requestJSON(`/api/search/?q=${query}/`, { signal: controller?.signal })
  } else {
    return await requestJSON(query)
  }
}

export async function getAllSearchResults (): Promise<SearchResult> {
  return await requestJSON('/api/search/')
}

export async function getFeaturedSearchResults (): Promise<SearchResult> {
  return await requestJSON('/api/collections/?title=Highlight')
}

// Facets
export interface Facet {
  name: string
  id: string
  url: string
  content_type: string
  options?: TopicFacet
}

export interface TopicFacet {
  is_faceted?: boolean
}
interface GetFacetResp {
  facets: Facet[]
}

export async function getFacets (): Promise<GetFacetResp> {
  return await requestJSON('/api/search/facets/')
}

export async function getFacetCategory (categoryName: string): Promise<SearchResult> {
  return await requestJSON(`/api/search/?category=${categoryName}/`)
}

// Topics
export async function getFacetTopic (topicName: string): Promise<SearchResult> {
  return await requestJSON(`/api/search/?topics=${topicName}/`)
}

// Membership
export async function getFacetMembership (isPremium: string): Promise<SearchResult> {
  return await requestJSON(`/api/search/?membership=${isPremium}/`)
}
